import { logger as i } from "../../utils/logger.js";
const c = "AmdLoader/AmdLoader.js", d = "bust=NO_CACHE_ID";
let n;
const u = [], s = [];
function g(e) {
  u.push(e);
}
function A(e) {
  s.push(e);
}
async function f() {
  const e = { DS: "." };
  let r = { paths: { ...e } }, o = Promise.resolve({});
  for (; u.length; )
    o = o.then(u.pop());
  try {
    r = await o;
  } catch (t) {
    i.error("[RequireJS] Failed to load config:", t);
  }
  return r.paths = { ...r.paths, ...e }, r.urlArgs || (r.urlArgs = d), r;
}
async function l() {
  let e = Promise.resolve(void 0);
  for (; s.length; )
    e = e.then(s.pop());
  try {
    await e;
  } catch (r) {
    i.error('[RequireJS] Failed to run "after require setup" hooks:', r);
  }
}
function p(e) {
  if (!window.require)
    throw new Error("window.require is not initialiazed");
  window.require.config(e), i.debug("[RequireJS] Set config:", e);
}
async function h(e) {
  if (typeof window.require == "function")
    return;
  const r = document.createElement("script"), o = new Promise((t, a) => {
    r.onload = t, r.onerror = a;
  });
  r.src = `${e.baseUrl ?? ""}${c}?${e.urlArgs}`, i.debug("[RequireJS] Download AMDLoader script: ", r.src), document.head.appendChild(r), await o;
}
async function q() {
  if (n)
    return n;
  let e;
  n = new Promise((o) => e = o), i.debug("[RequireJS] init");
  const r = await f();
  await h(r), await p(r), await l(), e == null || e();
}
export {
  g as addHookConfig,
  A as addHooksAfterRequireSetup,
  f as getRequireConfig,
  q as initRequire,
  l as runAfterRequireSetupHook,
  p as setupRequireConfig
};
